import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAdministrationTransporteurs } from 'store/administration/administrationActions';
import { fetchDepotsGestion } from 'store/depotGestion/depotGestionActions';
import { patchTransporteurCompte } from 'store/administration/administrationActions';
import AdministrationTransporteurCompte from './AdministrationTransporteurCompte';
import withLoader from 'components/Shared/withLoader';

const AdministrationTransporteurCompteWithLoader = withLoader(AdministrationTransporteurCompte);

class AdministrationTransporteurCompteContainer extends React.Component {
    
    constructor(props) {
        super(props);

        this.state = {
            transporteurCompte: props.transporteurCompte,
            depotGestionIndex : 0
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationTransporteurs();
        await this.props.fetchDepotsGestion();
    }
     
    componentDidUpdate(prevProps) {
        let { transporteurCompte } = this.props;

        if (transporteurCompte && !prevProps.transporteurCompte) {
            this.setState({ transporteurCompte: JSON.parse(JSON.stringify(transporteurCompte)), depotGestionIndex: 0 });
        }
    }


    handleChange = (event) => {
        let newTransporteurCompte = { ...this.state.transporteurCompte };        
        newTransporteurCompte[event.target.name] = event.target.value;
        this.setState({ ...this.state, transporteurCompte: newTransporteurCompte });
    };


    handleChangeDepotGestionIndex = (index) => {
        this.setState({ ...this.state, depotGestionIndex: index });
    };

    
    handleClickAddDepot = () => {
        let { depotsGestion } = this.props;
        let { depotGestionIndex } = this.state;

        let newTransporteurCompte = { ...this.state.transporteurCompte }; 
        newTransporteurCompte.depotsGestion = [...newTransporteurCompte.depotsGestion, depotsGestion[depotGestionIndex]];        
        this.setState({ ...this.state, transporteurCompte: newTransporteurCompte }); 
    };
    
    handleClickRemoveDepot = (index) => {   
        let newTransporteurCompte = { ...this.state.transporteurCompte };
        newTransporteurCompte.depotsGestion = newTransporteurCompte.depotsGestion.map((x, i) => i === index ? null : x).filter(x => x !== null);
        this.setState({ ...this.state, transporteurCompte: newTransporteurCompte }); 
    };

    

    handleClickSave = async () => {
        await this.props.patchTransporteurCompte(this.props.id, this.state.transporteurCompte);
    };



    render() {
        const { isLoading, isPatching, transporteurs, transporteur } = this.props;
        const { transporteurCompte, depotGestionIndex } = this.state;

        let sauvegardable = !!transporteurCompte && transporteurCompte.compte.length > 0;


        return (
            <AdministrationTransporteurCompteWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                transporteurs={transporteurs}

                selectedTransporteur={transporteur}
                transporteurCompte={transporteurCompte}
                               
                onChange={this.handleChange}
                onClickSave={this.handleClickSave}         

                depotGestionIndex={depotGestionIndex}
                setDepotGestionIndex={this.handleChangeDepotGestionIndex}
                onClickAddDepot={this.handleClickAddDepot}
                onClickRemoveDepot={this.handleClickRemoveDepot}

                sauvegardable={sauvegardable}
            />);
    }
}

AdministrationTransporteurCompteContainer.propTypes = {
    id: PropTypes.number,
    subid: PropTypes.number    
};


const mapStateToProps = (state, props) => {
    
    let transporteurs = state.administration.transporteurs.items;
    let transporteur = transporteurs ? state.administration.transporteurs.items.find(x => x.id === props.id) : null;
    let transporteurCompte = transporteur ? transporteur.comptes.find(y => y.id === props.subid) : null;
    
    return {
        isLoading: state.administration.transporteurs.isLoading,
        isPatching: state.administration.transporteurs.isPatching,
        transporteurs: transporteurs,
        transporteur: transporteur,
        transporteurCompte: transporteurCompte,
        depotsGestion: state.depotGestion.depotsGestion.items
    };
};


const mapDispatchToProps = {
    fetchAdministrationTransporteurs,
    fetchDepotsGestion,
    patchTransporteurCompte
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationTransporteurCompteContainer);